const docFileFormat = '.doc, .docx, .xls, .xlsx, .ppt, .pptx'
const imgFileFormat = '.jpeg, .jpg, .pdf, .png'
export const fileAcceptFormats = `${docFileFormat}, ${imgFileFormat}`
export const fileMaxSize = 1024 * 1024 * 80
